//these common for all
export const ADMIN_PRODUCT_REQUEST = "ADMIN_PRODUCT_REQUEST";
export const ADMIN_PRODUCT_FALIURE = "ADMIN_PRODUCT_FALIURE";

//post
export const ADMIN_ADD_PRODUCT_SUCCESS = "ADMIN_ADD_PRODUCT_SUCCESS";

//get
export const ADMIN_GET_PRODUCT_SUCCESS = "ADMIN_GET_PRODUCT_SUCCESS";

//patch
export const ADMIN_EDIT_PRODUCT_SUCCESS = "ADMIN_EDIT_PRODUCT_SUCCESS";

//delete
export const ADMIN_DELETE_PRODUCT = "ADMIN_DELETE_PRODUCT";
